import { Link } from "react-router-dom";

/**
 * Lets the user know they must login
 * @returns html letting the user know they must login to view further content
 */
const PleaseLogin = () => {
  return (
    <div className="flex items-center justify-center w-screen flex-1 bg-indigo-500 h-full">
      <div className="px-2 py-10 md:px-32 md:py-16 bg-white rounded-md shadow-xl">
        <div className="flex flex-col items-center">
          <h1 className="font-bold text-indigo-500 text-4xl">Please Login</h1>
          <p className="mt-4 mb-4 text-center text-gray-500 md:text-lg max-w-xs sm:max-w-md">
            This page allows you to see
            <span className="text-red-500"> cumulative statistics </span>
            about the games you've played. Please login to see this page.
          </p>
          <Link to="/login">
            <button className="outline outline-indigo-500 font-semibold outline-2 hover:bg-indigo-500 text-sm rounded-sm text-center py-2 px-6">
              Login
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PleaseLogin;
